import Vue from 'vue'
import Vuex from 'vuex'
import {serverAddress, FeathersVuex} from '../feathers-client'
import auth from './store.auth'

Vue.use(Vuex);
Vue.use(FeathersVuex);

const requireModule = require.context(
    // The path where the service modules live
    './services',
    // Whether to look in subfolders
    false,
    // Only include .js files (prevents duplicate imports`)
    /.js$/
);
const servicePlugins = requireModule
    .keys()
    .map(modulePath => requireModule(modulePath).default);

export default new Vuex.Store({
    state: {
        snackBarContent: '',
            
        prefilledCompanyId: sessionStorage.getItem('prefilledCompanyId') || ''
    },
    mutations: {
        setSnackBarContent(state, content) {
            state.snackBarContent = content;
        },
        setPrefilledCompanyId(state, companyId) {
            state.prefilledCompanyId = companyId;
            sessionStorage.setItem('prefilledCompanyId', companyId);
        }
    },
    actions: {
        showSnackBar({commit}, content) {
            commit('setSnackBarContent', content);
        },
        getServerTime() {
            return new Promise((resolve, reject) => {
                Vue.http.get(`${serverAddress}/getServerTime`)
                .then((response) => {
                    resolve(response.body);
                })
                .catch((error) => {
                    console.error(error);
                });
            });
        },
    },
    plugins: [...servicePlugins, auth]
})